import styled, { css } from "styled-components";
import { Button } from "primereact/button";
import breakpoints from "utils/breakpoints";

export const bannerGradient = (invert) => css`
  background: rgb(252, 228, 1);
  ${invert
    ? "background: radial-gradient(circle, #fece2f 99%, rgba(252,228,1,1) 0%);"
    : "background: radial-gradient(circle, rgba(252,228,1,1) 0%, #fece2f 99%);"}
`;

export const BannerGradient = styled.div`
  ${bannerGradient()}
  display: flex;
  justify-content: space-between;
  position: relative;
  flex-wrap: wrap;

  & > :first-child {
    width: 45%;
    padding-top: 1.5rem;
    padding-left: 6rem;
    ${breakpoints.mdMax`
          width: 100%;
          padding: 1rem;
        `}
  }
`;

export const BannerTitle = styled.h1`
  font-family: "Neucha", cursive;
  font-size: 3rem;
  color: #000000;
`;

export const BannerButton = styled(Button)`
  &&& {
    display: flex;
    color: white;
    border-color: #333;
    background-color: #111;
    margin: 2rem 0;

    & > :first-child {
      margin-bottom: 0.17rem;
    }
  }
`;

export const BannerImageContainer = styled.div`
  width: 55%;
  max-height: 100%;
  ${breakpoints.mdMax`
    width: 100%;
    max-height: auto;
  `}

  & .banner-image {
    position: absolute;
    top: 90%;
    transform: translate(0, -50%);
    ${breakpoints.mdMax`
      position: relative;
      top: 70%;
    `}
  }
`;
